module.exports = __webpack_public_path__ + "img/qrcode.25138ae8.png";